/* eslint-disable import/no-named-as-default */
import GuildSettled from '~/pages/GuildSettled/reducers'
import DistributorManageSuper from '~/pages/Coinagency/DistributorManageSuper/reducers'
import WelcomePack from '~/pages/WelcomePack/reducer'
import HelpCenter from '~/pages/HelpCenter/reducers'
import LuckyGift from '~/pages/LuckyGift/reducers'
import SalaryFeedback from '~/pages/Union/Anchor/SalaryFeedback/reducers'
import NormalSend from '~/pages/Send/reducers'
import UserVerification from '~/pages/game/UserVerification/reducers'
import game from './game'
import wallet from './wallet'
import Hunting from '../pages/Hunting/reducers'
import FeedBack from '../pages/Feedback/reducers'
import AnchorCenter from '../pages/AnchorCenter/reducers'
import UnionGatherInfo from '../pages/Union/GatherInfo/reducers'
import AnchorQuitList from './AnchorQuitList'
import AnchorQuit from './AnchorQuit'
import CoinsAgencyWallet from '../pages/CoinsAgency/reducers'
import SalaryWallet from '../pages/Union/SalaryWallet/reducers'
import FirstCharge from '../pages/FirstCharge/reducers'
import Lord from '../pages/lord/pages/home/reducers'
import Svip from '../pages/Svip/pages/home/reducers'
import UserInfoCollection from '../pages/UserInfoCollection/reducers'
import HabiWallet from '../pages/Wallet/reducers'
import BdCenter from '../pages/BdCenter/reducers'

export default {
  ...game,
  ...wallet,
  HabiWallet,
  BdCenter,
  DistributorManageSuper,
  Lord,
  Svip,
  Hunting,
  FeedBack,
  AnchorCenter,
  UnionGatherInfo,
  AnchorQuitList,
  AnchorQuit,
  CoinsAgencyWallet,
  SalaryWallet,
  FirstCharge,
  UserInfoCollection,
  GuildSettled,
  HelpCenter,
  SalaryFeedback,
  NormalSend,
  WelcomePack,
  UserVerification,
  LuckyGift,
}
